import { useGetSoftwareList } from './useSoftware';

/**
 * providerDomain으로 소프트웨어 1건을 조회하여 providerId를 추출하는 훅
 * - 백엔드 소프트웨어 API가 providerDomain → providerId 매핑을 처리
 */
export const useProviderIdByDomain = (providerDomain?: string): string | undefined => {
  const { data } = useGetSoftwareList(
    { providerDomain, size: 1 },
    { enabled: !!providerDomain },
  );

  return data?.content[0]?.providerId ?? undefined;
};
